import {
    BULK_UPDATE_EVENT_ATTENDANCE_FAILURE,
    BULK_UPDATE_EVENT_ATTENDANCE_SUCCESS,
    DECLARE_MY_EVENT_ABSENCE_FAILURE,
    DECLARE_MY_EVENT_ABSENCE_SUCCESS,
    FETCH_EVENT_ATTENDANCE_FAILURE,
    FETCH_EVENT_ATTENDANCE_SUCCESS,
    SET_EVENT_ATTENDANCE_ERROR,
    SET_EVENT_ATTENDANCE_LOADING,
    SET_EVENT_ATTENDANCE_SUBMITTING,
} from "../actions/eventAttendanceActions";

const initialState = {
    loading: false,
    submitting: false,
    error: null,
    byEventSession: {},
    bulkResult: null,
    myAbsenceResult: null,
    lastUpdatedEventId: null,
};

export default function eventAttendanceReducer(state = initialState, action) {
    switch (action.type) {
        case SET_EVENT_ATTENDANCE_LOADING:
            return { ...state, loading: action.payload };
        case SET_EVENT_ATTENDANCE_SUBMITTING:
            return { ...state, submitting: action.payload };
        case SET_EVENT_ATTENDANCE_ERROR:
            return { ...state, error: action.payload };
        case FETCH_EVENT_ATTENDANCE_SUCCESS:
            return {
                ...state,
                byEventSession: {
                    ...state.byEventSession,
                    [`${action.payload.eventId}:${action.payload.sessionId}`]: action.payload.items || [],
                },
                error: null,
            };
        case BULK_UPDATE_EVENT_ATTENDANCE_SUCCESS:
            return {
                ...state,
                bulkResult: action.payload.result,
                lastUpdatedEventId: `${action.payload.eventId}:${action.payload.sessionId}`,
                error: null,
            };
        case DECLARE_MY_EVENT_ABSENCE_SUCCESS:
            return {
                ...state,
                myAbsenceResult: action.payload.result,
                lastUpdatedEventId: `${action.payload.eventId}:${action.payload.sessionId}`,
                error: null,
            };
        case FETCH_EVENT_ATTENDANCE_FAILURE:
        case BULK_UPDATE_EVENT_ATTENDANCE_FAILURE:
        case DECLARE_MY_EVENT_ABSENCE_FAILURE:
            return {
                ...state,
                error: action.payload,
            };
        default:
            return state;
    }
}
